import React, { useState } from "react";
import { Div, Text, Row, Col, Image, Button, Anchor } from "atomize";
import {
  getUTMcookie,
  addUtmToUrl,
  addUtmInputValues,
} from "../../utilities/helpers";
import BrandApplicationModal from "../../modals/BrandApplicationModal";

const PricingHero = ({ content, modalContent }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <Div>
      <Div
        p={{
          t: { xs: "4rem", md: "3.625rem" },
          x: { xs: "2rem", md: "0" },
          b: "6.25rem",
        }}
        maxW="49.5rem"
        m="auto"
        textAlign="center"
        className="pricing-hero"
      >
        <Div maxW="49.4rem" m="auto">
          <Text
            className="white-text-gradient"
            textTransform="uppercase"
            d="inline"
            textWeight="700"
            tag="h2"
            textSize={{ xs: "caption1", md: "body" }}
            style={{ letterSpacing: "2px" }}
          >
            {content.headerGradientText}
          </Text>
          <Div m={{ t: { xs: "14px", md: "1.2rem" } }}>
            <Text
              className="heading"
              maxW="38.9rem"
              m="auto"
              tag="h1"
              dangerouslySetInnerHTML={{ __html: content.headerHeading }}
            ></Text>
          </Div>
          <Div m={{ t: { xs: "14px", md: "1.5rem" } }}>
            <Text
              className="sub-heading"
              textSize={{ xs: "subheader1", md: "heading3" }}
              maxW="38.9rem"
              m="auto"
            >
              {content.headerText}
            </Text>
          </Div>
          <Div textAlign="center">
            <Div
              // onClick={() => setShowModal(true)}

              onClick={() => {
                const tags = getUTMcookie();
                const url = addUtmToUrl("https://app.trend.io/signup", tags);
                window.location.href = url;

                // console.log({ url });
              }}
              cursor="pointer"
              className="get-started"
              d="inline-block"
              bg="primary"
              textColor="black"
              textWeight="800"
              textSize="subheader6"
              style={{ lineHeight: "18px" }}
              m={{ x: "auto", t: { xs: "3.8rem", md: "2.6rem" } }}
              p={{ x: "1.5rem", y: "1.1rem" }}
            >
              {content.headerBtnText}
            </Div>
            <Div textSize="caption2" m={{ t: "0.8rem" }} textWeight="500">
              {content.headerFooterText}
            </Div>
          </Div>
        </Div>
        <Div
          d="flex"
          align="center"
          justify="space-between"
          flexDir={{ xs: "column", md: "row" }}
          m={{ t: "3.25rem", x: "auto" }}
        >
          <Div
            flexGrow="1"
            textAlign={{ xs: "center", md: "start" }}
            maxW="158px"
            m={{ b: { xs: "5rem", md: "0" } }}
          >
            <Image src="/images/crowd-brand.png" h="2.6rem" w="auto" />
          </Div>
          <Div
            flexGrow={{ xs: "1", md: ".8" }}
            m={{ b: { xs: "5.25rem", md: "0" } }}
          >
            <Image src="/images/fb-marketing.png" h="2.375rem" w="auto" />
          </Div>
          <Div
            flexGrow={{ xs: "1", md: ".6" }}
            m={{ b: { xs: "5.25rem", md: "0" } }}
          >
            <Image src="/images/G2_Leader.svg" h="4.1rem" w="auto" />
          </Div>
          <Div
            flexGrow={{ xs: "1", md: ".5" }}
            textAlign={{ xs: "center", md: "end" }}
          >
            <Image src="/images/capterra-2.png" h="2.75rem" w="auto" />
          </Div>
        </Div>
        <BrandApplicationModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          modalContent={modalContent}
        />
      </Div>
    </Div>
  );
};

export default PricingHero;